<template>
  <div class="contact-partner-form">
    <template v-if="!hasContactPerson">
      <p v-if="availableUsers.length > 0">
        Wählen Sie einen bestehenden Benutzer als Ansprechpartner aus.
        Wenn der Benutzer keine Administrationsrechte besitzt, werden diese automatisch zugewiesen.
      </p>
      <p v-else>
        Der Vertriebspartner hat keine Benutzer.
      </p>
      <BaseSelect
        v-model="selectedUserId"
        :items="availableUsers"
        label="Ansprechpartner"
        outlined
        rounded
        list-relative
        searchable
        :disabled="availableUsers.length === 0"
      />
      <BaseFormControls
        class="justify-end"
        :next-disabled="availableUsers.length === 0"
        @next="submit"
      >
        <template #next>
          Speichern
        </template>
      </BaseFormControls>
    </template>
    <SimpleDynamicForm
      v-else
      :action="action"
      :items="items"
      :cols="cols"
      :subtitle="subtitle"
      :reference="reference"
      @close="emit('close')"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import axios from 'axios';

import { responseHandler } from '@/helper';

import SimpleDynamicForm from '@/components/SimpleDynamicForm.vue';

import type {
  FormItem, Reference,
} from '@/apps/order/interfaces/ContactPartnerFormInterface';
import BaseSelectInterface from '@/interfaces/BaseSelectInterface';

const props = withDefaults(defineProps<{
  action: string;
  items: FormItem[];
  cols?: number;
  subtitle?: string;
  reference?: Reference | undefined;
  hasContactPerson?: boolean;
  availableUsers?: BaseSelectInterface[];
}>(), {
  cols: 2,
  subtitle: '',
  reference: undefined,
  hasContactPerson: true,
  availableUsers: () => [],
});

const emit = defineEmits<{
  (event: 'close'): void;
}>();

const selectedUserId = ref<number | null>(null);

const submit = () => {
  if (!selectedUserId.value) return;

  axios.post(props.action, { user_id: selectedUserId.value }).then((response) => {
    responseHandler(response, true, false);
    emit('close');

    if (props.reference) {
      const payload: any = response.data;
      props.reference.success({
        data: payload,
        hasContactPerson: true,
        items: payload && payload.action && payload.action.items ? payload.action.items : props.items,
      });

      // TODO: Remove reload if the card is updated
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
  }).catch((error) => {
    if (error.response) {
      responseHandler(error.response, false, false);
    }
  });
};
</script>

<style lang="scss" scoped>
.contact-partner-form {
  display: grid;
  gap: 0.875rem;
}
</style>
